import { render } from "./customergroup.vue?vue&type=template&id=29ce9bb9"
import script from "./customergroup.vue?vue&type=script&lang=js"
export * from "./customergroup.vue?vue&type=script&lang=js"

import "./customergroup.vue?vue&type=style&index=0&id=29ce9bb9&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__